import React from 'react';
import { Hero } from './components/sections/Hero';
import { PainPoints } from './components/sections/PainPoints';
import { Outcomes } from './components/sections/Outcomes';
import { Modules } from './components/sections/Modules';
import { Bonuses } from './components/sections/Bonuses';
import { ForYou } from './components/sections/ForYou';
import { FeaturedStory } from './components/sections/FeaturedStory';
import { Testimonials } from './components/sections/Testimonials';
import { WhatYouGet } from './components/sections/WhatYouGet';
import { Offer } from './components/sections/Offer';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <main className="w-full bg-sand-100" data-id="element-0" data-mp="28u5y0mx2p5cu">
      <Hero data-id="element-1" data-mp="28t4kmbsl46ry" />
      <PainPoints data-id="element-2" data-mp="28sur4e8bzhhi" />
      <Outcomes data-id="element-3" data-mp="28s2xva27hvue" />
      <Modules data-id="element-4" data-mp="23vcmh01cjofb" />
      <Bonuses data-id="element-5" data-mp="23vupcfiil0w7" />
      <ForYou data-id="element-6" data-mp="23u9v6r043jyv" />
      <FeaturedStory data-id="element-7" data-mp="23utbk3a460as" />
      <Testimonials data-id="element-8" data-mp="23t8gmcjw0fce" />
      <WhatYouGet data-id="element-9" data-mp="3ijxsv0nzqion" />
      <Offer data-id="element-10" data-mp="3ikr002qv3a7b" />
      <FAQ data-id="element-11" data-mp="3iiwfuqnezm4a" />
      <FinalCTA data-id="element-12" data-mp="3ijfwm41bw4gq" />
      <Footer data-id="element-13" data-mp="3ijpef4c7z5bc" />
    </main>;
}